<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>app链接路径设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <Creat></Creat>

        <el-input placeholder="请输入lineUrl" clearable v-model="lineUrl">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="tenantId" placeholder="租户选择" clearable>
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <el-select
          v-model="speedTestType"
          placeholder="测速类型"
          style="width: 200px"
          @change="handleSpeedTypeChange"
        >
          <el-option
            v-for="item in speedTestOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button :loading="speedTesting" @click="handleBatchSpeedTest"
          >测速</el-button
        >
      </div>
      <div>
        <List></List>
        <PageNation
          :total="totalCount"
          :size="size"
          :page="page"
          @pageChanged="handlePageChanged($event)"
        ></PageNation>
      </div>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState } from "vuex";
import Creat from "./components/creat";
import List from "./components/list";
import PageNation from "../../../components/pagination";
import { tenantInfo } from "@/common/publicApi";
import { SPEED_TEST_OPTIONS } from "./speedTest";
export default {
  name: "appLineUrl",
  data() {
    return {
      dialogVisible: false,
      lineUrl: "",
      speedTestOptions: SPEED_TEST_OPTIONS,
      options: [
        {
          value: "zh",
          label: "中文",
        },
      ],
      total: "",
      page: 1,
      size: 10,
      obj: {},
      tenantId: "",
      tenantList: [],
    };
  },
  components: {
    Creat,
    List,
    PageNation,
  },

  computed: {
    ...mapState("appLineUrl", ["codelist", "totalCount", "speedTesting"]),
    speedTestType: {
      get() {
        return this.$store.state.appLineUrl.speedTestType;
      },
      set(val) {
        this.$store.commit("appLineUrl/setSpeedTestType", val);
      },
    },
  },

  methods: {
    ...mapActions("appLineUrl", ["getlist", "getUrlList", "runBatchSpeedTest"]),
    handleSpeedTypeChange() {
      this.runBatchSpeedTest();
    },
    handleBatchSpeedTest() {
      this.runBatchSpeedTest();
    },
    closeDialog() {},
    getData() {
      this.getUrlList({
        lineUrl: this.lineUrl,
        page: 1,
        size: this.size,
        tenantId: this.tenantId,
      });
    },
    async handleSearch() {
      const res = await this.getUrlList({
        lineUrl: this.lineUrl,
        page: 1,
        size: this.size,
        tenantId: this.tenantId,
      });
    },
    handlePageChanged(e) {
      this.page = e.page;
      this.size = e.size;
      this.obj = { ...this.obj, ...e };
      this.getUrlList({
        ...this.obj,
        lineUrl: this.lineUrl,
        tenantId: this.tenantId,
      });
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
  },
};
</script>

<style lang="less" scoped></style>
